import { createStore } from 'vuex';

import exportPotentialMap from '@/app/modules/ExportPotential/state/map';
import measure from '@/app/modules/MeasuresTtrStd/store';
import navigator from '@/app/modules/MemberNavigator/store';
import auth from '@/app/modules/auth/store';
import authSyncPlugin from '@/app/modules/auth/store/auth-sync';
import { STATUS, canRequest, createAsyncState } from '@/app/shared/state/asyncState';
import links from '@/app/shared/state/links';
import request from '@/app/shared/state/request';

import home from '../../modules/Home/state/index';
import agreements from '../../modules/InternationalTrade/store/index';
import marketAccess from '../../modules/MarketsAccess/state/index';
import nsi from './nsi';
import nsitnved from './nsitnved';
import selects from './selects/index';

export default createStore({
  plugins: [authSyncPlugin],
  state: {
    news: [],
    menu: createAsyncState([]),
  },
  getters: {
    allNews(state) {
      return state.news;
    },
    getMenu(state) {
      return state.menu.data;
    },
  },
  mutations: {
    updateNews(state, news) {
      state.news = news;
    },
    updateMenu(state, response) {
      const menuData = response?.data;
      state.menu.data = Array.isArray(menuData) ? menuData : [];
      state.menu.status = STATUS.SUCCESS;
    },
    setMenuStatus(state, status) {
      state.menu.status = status;
    },
  },
  actions: {
    getNews(ctx) {
      setTimeout(() => {
        const news = [
          {
            title: 'Готовятся новые меры увеличения экспорта древесины из Индии',
            date: '11.12.2022',
            img: require('../../../assets/img/home/newsSlide1.jpg'),
            link: '/market-access/action-list/India',
          },
          {
            title: 'Обзор СМИ по внешнеэкономической тематике за период с 22.11.2021 по 28.11.2021',
            date: '12.07.2022',
            img: require('../../../assets/img/home/newsSlide4.jpg'),
            link: '/market-access/action-list/India',
          },
          {
            title: 'Пекин заявил, что встреча глав правительств КНР и РФ нацелена на стабилизацию поставок',
            date: '12.02.2022',
            img: require('../../../assets/img/home/newsSlide3.jpg'),
            link: '/market-access/action-list/India',
          },
          {
            title: 'Представители России и Франции договорились о развитии сотрудничества в сфере инноваций',
            date: '10.12.2022',
            img: require('../../../assets/img/home/newsSlide2.jpg'),
            link: '/market-access/action-list/India',
          },
        ];
        ctx.commit('updateNews', news);
      }, 200);
    },

    async getMenu(context, params = {}) {
      if (!canRequest(context.state.menu)) {
        return;
      }

      context.commit('setMenuStatus', STATUS.LOADING);

      const result = await request(
        context,
        {
          url: links.menu.getMenu,
          mutate: 'updateMenu',
          name: 'getMenu',
        },
        params,
      );
      if (result && result.error) {
        context.commit('setMenuStatus', STATUS.ERROR);
      }
      return result;
    },
  },
  modules: {
    auth,
    navigator,
    home,
    marketAccess,
    selects,
    exportPotentialMap,
    agreements,
    ...measure,
    nsitnved,
    nsi,
  },
});
